'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Checkbox = require('./Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Checkbox2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/Checkbox/index.js
 ** module id = 437
 ** module chunks = 0
 **/